import { companyApis } from '@apis/dashboard/companyApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useCompanyItem = createUseQuery(
  (id: number) => [`/dashboard/company/${id}/`],
  (id: number) => async () =>
    companyApis
      .get('/dashboard/company/{id}/', {
        path: { id },
      })
      .then((r) => r[200]!),
);
